import * as React from 'react';
import {Helmet} from 'react-helmet-async';

export const RUM = () => (
  // This does environment determination fully on the client, so that we don't need to have any
  // janky string interpolation here, which de-risks breakage in subtle ways that can't be covered by
  // the current test suite
  <Helmet>
    <script type="text/javascript">
      {`
    (function (){
      var env = 'production';
      if (location.host.indexOf('dev.devoted.com') > -1 || location.host.indexOf('localhost') > -1) {
        env = 'development';
      } else if (location.host.indexOf('staging.devoted.com') > -1) {
        env = 'staging';
      }
      var hostname = location.host;
      var service = 'devoted-com';
      (function(h,o,u,n,d) {
        h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
        d=o.createElement(u);d.async=1;d.src=n
        n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
      })(window,document,'script','https://www.datadoghq-browser-agent.com/us1/v5/datadog-rum.js','DD_RUM')
      window.DD_RUM.onReady(function() {
        window.DD_RUM.init({
          clientToken: 'pube89789739d93a56cc21577495f81b178',
          applicationId: 'c8f2e1c4-7d18-44ed-a7b7-1d2120b38b9c',
          site: 'datadoghq.com',
          service: service,
          //  service: 'my-web-application',
          env: env,
          allowedTracingUrls: [/https:\\/\\/.*\\.devoted\\.com/],
          sessionSampleRate: 100,
          sessionReplaySampleRate: 0,
          trackResources: true,
          trackLongTasks: true,
          trackUserInteractions: false,
        });
      })
    })();
        `}
    </script>
  </Helmet>
);
